import { XClose } from "@untitledui/icons";
import { useEffect } from "react";
import type { SideModalProps } from "../types";

export const SideModal = ({
	isOpen,
	onClose,
	children,
	footer,
	title,
	width = "400px",
}: SideModalProps) => {
	useEffect(() => {
		const handleEscape = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				onClose();
			}
		};

		if (isOpen) {
			document.addEventListener("keydown", handleEscape);
			document.body.style.overflow = "hidden";
		}

		return () => {
			document.removeEventListener("keydown", handleEscape);
			document.body.style.overflow = "unset";
		};
	}, [isOpen, onClose]);

	if (!isOpen) {
		return null;
	}

	return (
		<div
			className="fixed top-0 right-0 z-10000 h-full translate-x-0 transform bg-white shadow-2xl transition-transform duration-300 ease-in-out"
			style={{ width }}
		>
			<div className="flex h-full flex-col">
				{title ? (
					<div className="flex items-center justify-between p-6">
						<h1 className="font-normal text-xl">{title}</h1>
						<button aria-label="Fechar modal" onClick={onClose} type="button">
							<XClose className="size-5 text-gray-500" />
						</button>
					</div>
				) : null}

				<div className="flex-1 overflow-y-auto p-6">{children}</div>

				{footer ? (
					<div className="shrink-0 border-gray-200 border-t">{footer}</div>
				) : null}
			</div>
		</div>
	);
};
